<div class="sidebar">
  <mat-nav-list>
    <a mat-list-item routerLink="home" (click)="toggleSideBar()">
      <mat-icon matListItemIcon aria-label="Planos e Produtos">
        <img src="assets/icons/icon_home.svg" alt="Ícone de Planos e Produtos" /> </mat-icon>
      <span matListItemTitle>HubMedical Home</span>
    </a>

    @if (isAuthenticated()) {

    <!-- Seção Perfil Provider PF -->
    @if (hasProviderPF()) {
    <mat-divider></mat-divider>
    <div class="profile-section">
      <div style="font-size: 0.8rem; width: 90%; padding-left: 45px;">
        Perfil {{ getProfileType(user.cpf!) }}
      </div>
      <a mat-list-item [routerLink]="['/providerPF', profileProviderPF.id]" (click)="toggleSideBar()">
        <mat-icon matListItemIcon aria-label="Dashboard">
          <img src="assets/icons/icon_dashboard.svg" alt="Ícone de Dashboard" />
        </mat-icon>
        <span matListItemTitle><b>{{ profileProviderPF.name }}</b></span>
      </a>

      @if(canAccess(user.cpf!)) {
      <a mat-list-item [routerLink]="['/providerPF', profileProviderPF.id, 'shareDocuments']" (click)="toggleSideBar()"
        class="submenu">
        <mat-icon matListItemIcon >
          <img src="assets/icons/icon_shareDoc.svg" alt="Ícone de Compartilhamento" />
        </mat-icon>Compartilhar Documentos
      </a>

      @if(hasFeatureAccess(user.cpf!, Feature.SERVICE_OFFERING)) {
      <a mat-list-item [routerLink]="['/providerPF', profileProviderPF.id, 'serviceOffering']" (click)="toggleSideBar()"
        class="submenu">
        <mat-icon matListItemIcon >
          <img src="assets/icons/icon_ofertas.svg" alt="Ícone de Ofertas" />
        </mat-icon>
        Ofertas de Consultas e Procedimentos
      </a>
      }

      @if(hasFeatureAccess(user.cpf!, Feature.NEGOTIATION)) {
      <a mat-list-item
        [routerLink]="['/providerPF', profileProviderPF.id, 'negotiationPainel', encriptCpfcnpj(profileProviderPF.cpf!)]"
        (click)="toggleSideBar()" class="submenu">
        <mat-icon matListItemIcon >
          <img src="assets/icons/icon_negociacoes.svg" alt="Ícone de Negociações" />
        </mat-icon>
        Negociações
      </a>
      }
      }

    </div>
    }

    <!-- Seção Perfis Provider PJ -->
    @if (hasProviderPJ()) { @for (profilePJ of profileProviderPJ; track
    profilePJ.id) {
    <mat-divider></mat-divider>
    <div class="profile-section">
      <div style="font-size: 0.8rem; width: 90%; padding-left: 45px;">
        Perfil {{ getProfileType(profilePJ.cnpj!) }}
      </div>

      <a mat-list-item [routerLink]="['/providerPJ', profilePJ.id]" (click)="toggleSideBar()">
        <mat-icon matListItemIcon  aria-label="Dashboard">
          <img src="assets/icons/icon_dashboard.svg" alt="Ícone de Dashboard" />
        </mat-icon>
        <b>{{ profilePJ.companyName }}</b>
      </a>

      @if(canAccess(profilePJ.cnpj!)) {
      @if(hasFeatureAccess(profilePJ.cnpj!, Feature.SHARE_DOCUMENTS)) {
      <a mat-list-item [routerLink]="['/providerPJ', profilePJ.id, 'shareDocuments']" (click)="toggleSideBar()"
        class="submenu">
        <mat-icon matListItemIcon  aria-label="Compartilhar Documentos">
          <img src="assets/icons/icon_shareDoc.svg" alt="Ícone de Compartilhamento de Documentos" />
        </mat-icon>
        Compartilhar Documentos
      </a>
      }

      @if(hasFeatureAccess(profilePJ.cnpj!, Feature.SERVICE_OFFERING)) {
      <a mat-list-item [routerLink]="['/providerPJ', profilePJ.id, 'serviceOffering']" (click)="toggleSideBar()"
        class="submenu">
        <mat-icon matListItemIcon >
          <img src="assets/icons/icon_ofertas.svg" alt="Ícone de Ofertas" />
        </mat-icon>
        Ofertas de Consultas e Procedimentos
      </a>
      }

      @if(hasFeatureAccess(profilePJ.cnpj!, Feature.RESOURCE_OFFERING)) {
      <a mat-list-item [routerLink]="['/providerPJ', profilePJ.id, 'resourceOffering']" (click)="toggleSideBar()"
        class="submenu">
        <mat-icon matListItemIcon  aria-label="Ofertas de Exames e Terapias">
          <img src="assets/icons/icon_ofertas.svg" alt="Ícone de Ofertas de Exames e Terapias" />
        </mat-icon>
        Ofertas de Exames e Terapias
      </a>
      }

      @if(hasFeatureAccess(profilePJ.cnpj!, Feature.SERVICE_DEMAND)) {
      <a mat-list-item [routerLink]="['/providerPJ', profilePJ.id, 'serviceDemand']" (click)="toggleSideBar()"
        class="submenu">
        <mat-icon matListItemIcon >
          <img src="assets/icons/icon_ofertas.svg" alt="Ícone de Ofertas" />
        </mat-icon>
        Demandas de Consultas e Procedimentos
      </a>
      }

      @if(hasFeatureAccess(profilePJ.cnpj!, Feature.RESOURCE_DEMAND)) {
      <a mat-list-item [routerLink]="['/providerPJ', profilePJ.id, 'resourceDemand']" (click)="toggleSideBar()"
        class="submenu">
        <mat-icon matListItemIcon  aria-label="Ofertas de Exames e Terapias">
          <img src="assets/icons/icon_ofertas.svg" alt="Ícone de Ofertas de Exames e Terapias" />
        </mat-icon>
        Demandas de Exames e Terapias
      </a>
      }

      @if(hasFeatureAccess(profilePJ.cnpj!, Feature.NEGOTIATION)) {
      <a mat-list-item
        [routerLink]="['/providerPJ', profilePJ.id, 'negotiationPainel', encriptCpfcnpj(profilePJ.cnpj!)]"
        (click)="toggleSideBar()" class="submenu">
        <mat-icon matListItemIcon >
          <img src="assets/icons/icon_negociacoes.svg" alt="Ícone de Negociações" />
        </mat-icon>
        Negociações
      </a>
      }

      }
    </div>
    }

    }
    @if(hasAnyActivePlan()){
    <mat-divider></mat-divider>
    <div class="profile-section">
      <a mat-list-item routerLink="search" (click)="toggleSideBar()">
        <mat-icon matListItemIcon >
          <img src="assets/icons/icon_dashboard.svg" alt="Ícone de Conta" /> </mat-icon><b>Pesquisas</b>
      </a>
    </div>
    }

    <!-- Seção Minha Conta -->
    <div class="profile-section">
      <a mat-list-item routerLink="my-account" (click)="toggleSideBar()">
        <mat-icon matListItemIcon >
          <img src="assets/icons/icon_dashboard.svg" alt="Ícone de Conta" /> </mat-icon><b>Minha Conta</b>
      </a>

      <!-- <a mat-list-item routerLink="my-account/user" (click)="toggleSideBar()" class="submenu">
            <mat-icon matListItemIcon >
              <img src="assets/icons/icon_cadastro.svg" alt="Ícone de Cadastro" /> </mat-icon>Meu Cadastro
          </a> -->

      <!-- <a mat-list-item routerLink="my-account/profiles" (click)="toggleSideBar()" class="submenu">
            <mat-icon matListItemIcon >
              <img src="assets/icons/icon_perfil.svg" alt="Ícone de Perfil" /> </mat-icon>Meus Perfis
          </a> -->

      <!-- <a mat-list-item routerLink="my-account/notification" (click)="toggleSideBar()" class="submenu">
            <mat-icon matListItemIcon  aria-label="Notificações">
              <img src="assets/icons/icon_notif.svg" alt="Ícone de Notificações" /> </mat-icon>Minhas Notificações
          </a> -->

      <!-- <a mat-list-item routerLink="my-account/my-plans" (click)="toggleSideBar()" class="submenu">
            <mat-icon matListItemIcon  aria-label="Meus Planos">
              <img src="assets/icons/icon_perfil.svg" alt="Ícone de Meus Planos" /> </mat-icon>Meus Planos
          </a> -->
    </div>

    }

    <a mat-list-item routerLink="shopping" (click)="toggleSideBar()">
      <mat-icon matListItemIcon  aria-label="Planos e Produtos">
        <img src="assets/icons/icon_pacotes.svg" alt="Ícone de Planos e Produtos" /> </mat-icon>Nossos Planos e Produtos
    </a>

    <a mat-list-item routerLink="faq" (click)="toggleSideBar()">
      <mat-icon matListItemIcon  aria-label="Perguntas Frequentes">
        <img src="assets/icons/icon_perguntas.svg" alt="Ícone de Perguntas Frequentes" /> </mat-icon>Ajuda - Perguntas
      Frequentes
    </a>

    <a mat-list-item routerLink="customer-service" (click)="toggleSideBar()">
      <mat-icon matListItemIcon  aria-label="Atendimento">
        <img src="assets/icons/icon_atendimento.svg" alt="Ícone de Atendimento" /> </mat-icon>SAC - Atendimento
    </a>

    @if(authCustomService.somePermission(['ADMIN','SUPPORT'])) {
    <mat-divider></mat-divider>
    <a mat-list-item routerLink="/admin" (click)="toggleSideBar()">
      Administrador do Sistema
    </a>
    }


  </mat-nav-list>
</div>